<div style="height: 100vh">
  <mat-toolbar class="nav-bar app-theme mat-elevation-z2">
    <mat-toolbar-row>
      <button mat-icon-button (click)="toggle()" fxShow="true" fxHide.gt-sm>
        <mat-icon>menu</mat-icon>
      </button>

      <!-- <span class="profile-image">
        <a href="#">
          <img src="../../../assets/QUIZHACK.png" alt="Web Icon" />
        </a>
      </span> -->
      <a href="/">
        <img
          mat-card-avatar
          class="icon-web"
          src="../../../assets/QUIZHACK.png"
        />
      </a>
      <div fxShow="true" fxHide.lt-md="true">
        <button mat-button [routerLink]="['/']">
          <strong> Quiz Hack</strong>
        </button>

        <button mat-button [routerLink]="['/quiz', 'Amazon']">
          <strong>Amazon Quiz</strong>
        </button>

        <!-- <button mat-button [routerLink]="['/quiz', 'Flipkart']">
          <strong> Flipkart Quiz</strong>
        </button> -->

        <button mat-button [routerLink]="['/disclaimer']">
          <strong> Disclaimer </strong>
        </button>
      </div>
      <!-- <img mat-card-avatar class="user-avatar" src="/src/QUIZHACK.png" /> -->
      <!-- *ngIf="appUser?.isAdmin" -->
      <ng-container *ngIf="appUser?.isAdmin">
        <button
          style="min-width: 30px"
          mat-button
          [routerLinkActive]="['link-active']"
          [routerLink]="['/addpost']"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </ng-container>
      <span class="spacer"></span>

      <button style="min-width: 10px" mat-button>
        <a
          href="https://play.google.com/store/apps/details?id=com.hostelmanager.quizhackk&hl=en_IN&gl=US"
          target="_blank"
          ><i class="fab fa-google-play" aria-hidden="true"></i>
          <span class="mr-3" fxShow="true" fxHide.lt-md="true"
            >Play Store</span
          ></a
        >
      </button>
      <ng-template #anonymousUser>
        <button mat-button (click)="login()">
          <i class="fab fa-google mr-1"></i> Sign In
        </button>
      </ng-template>
      <ng-container *ngIf="appUser; else anonymousUser">
        <img mat-card-avatar class="user-avatar" src="{{ appUser.photoURL }}" />
        <!-- {{ appUser.name | titlecase }} -->
        <button mat-button [matMenuTriggerFor]="menu">
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <b disabled mat-menu-item>{{ appUser.name | titlecase }}</b>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      </ng-container>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-sidenav-container fxFlexFill>
    <mat-sidenav class="sideNav" #sidenav>
      <mat-nav-list class="justify-content-center">
        <a
          class="side-nav-content"
          (click)="sidenav.toggle()"
          href=""
          mat-list-item
          >Close</a
        >

        <button
          (click)="toggle()"
          class="btn side-nav-content"
          mat-list-item
          [routerLink]="['/']"
        >
          <strong> Home </strong>
        </button>

        <button
          (click)="toggle()"
          class="btn side-nav-content"
          mat-list-item
          [routerLink]="['/quiz', 'Amazon']"
        >
          <strong>Amazon Quiz</strong>
        </button>

        <!-- <button
          (click)="toggle()"
          class="btn side-nav-content"
          mat-list-item
          [routerLink]="['/quiz', 'Flipkart']"
        >
          <strong> Flipkart Quiz</strong>
        </button> -->

        <button
          (click)="toggle()"
          class="btn side-nav-content"
          mat-list-item
          [routerLink]="['/disclaimer']"
        >
          <strong> Disclaimer </strong>
        </button>
        <app-footer></app-footer>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content fxFlexFill>
      <div class="container">
        <mat-card class="mat-bg mat-elevation-z2 mb-3">
          <router-outlet></router-outlet>
          <app-footer></app-footer>
        </mat-card>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
